export const startInterval = (reference) => {
    if (!reference.current) {
        reference.current = setInterval(() => {
            window.Vagon?.focusIframe();
        }, 500);
    }
};

export const startRSInterval = (reference) => {
    if (!reference.current) {
        reference.current = setInterval(() => {
            const iframe = document.getElementById("render-streaming-container");
            if (iframe && typeof iframe.focus === "function") {
                iframe.focus();
            }
        }, 500);
    }
};

export const stopInterval = (reference) => {
    if (reference.current) {
        clearInterval(reference.current);
        reference.current = null;
    }
};

const handleButtonClick = () => {
    const escapeKeyEvent = new KeyboardEvent("keydown", {
        key: "Escape",
    });

    document.dispatchEvent(escapeKeyEvent);
};

export const alterState = (setState) => {
    handleButtonClick();
    setState((prev) => !prev);
    handleButtonClick();
};

export const sendVagonMessage = (message) => {
    if (window.Vagon && localStorage.getItem("isDCVPlay") === "false") {
        window.Vagon.sendApplicationMessage(message);
    }
};

export const sendRenderStreamMessage = (message, socket) => {
    // if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
    // }
};
